'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _webSso = require('@vezeeta/web-sso');

var _workingHours = require('../actions/workingHours');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(loadWorkingHours),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(saveWorkingHours),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(workingHoursSaga);

function loadWorkingHours(action) {
  var apiObj, accountRoomModelsObj, workingHours;
  return _regenerator2.default.wrap(function loadWorkingHours$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          apiObj = new _webSso.AuthApi();
          accountRoomModelsObj = [];

          action.doctors.forEach(function (accountKey) {
            action.rooms.forEach(function (roomKey) {
              accountRoomModelsObj.push({
                AccountKey: accountKey,
                RoomKey: roomKey
              });
            });
          });
          _context.next = 5;
          return apiObj.post(_webUtils.Urls.getWorkingHours, {
            AccountRoomModels: accountRoomModelsObj,
            scheduleKey: action.additionalParams.scheduleKey && action.additionalParams.scheduleKey,
            Date: action.additionalParams.date && action.additionalParams.date
          });

        case 5:
          workingHours = _context.sent;

          if (!(Math.floor(workingHours.status / 100) === 2)) {
            _context.next = 13;
            break;
          }

          _context.next = 9;
          return (0, _effects.put)({ type: 'WORKING_HOURS_LOAD_DONE', rooms: workingHours });

        case 9:
          _context.next = 11;
          return (0, _effects.put)({
            type: _workingHours.WORKING_HOURS.LOAD_SUCCESS,
            rooms: workingHours.data
          });

        case 11:
          _context.next = 15;
          break;

        case 13:
          _context.next = 15;
          return (0, _effects.put)({ type: 'WORKING_HOURS_LOAD_FAIL' });

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}
function saveWorkingHours(action) {
  var apiObj, workingHours, reservationOptions, setScheduleTypes;
  return _regenerator2.default.wrap(function saveWorkingHours$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          apiObj = new _webSso.AuthApi();
          _context2.next = 3;
          return apiObj.post(_webUtils.Urls.saveWorkingHours, _extends({
            scheduleKey: action.scheduleKey
          }, action.keys));

        case 3:
          workingHours = _context2.sent;
          _context2.next = 6;
          return apiObj.post(_webUtils.Urls.setAllowReservationWindow, action.reservationOptions);

        case 6:
          reservationOptions = _context2.sent;
          _context2.next = 9;
          return apiObj.post(_webUtils.Urls.setScheduleTypes, action.scheduleTypes);

        case 9:
          setScheduleTypes = _context2.sent;

          if (!(_webUtils.STATUS.isSuccess(workingHours.status) && _webUtils.STATUS.isSuccess(reservationOptions.status) && _webUtils.STATUS.isSuccess(setScheduleTypes.status))) {
            _context2.next = 17;
            break;
          }

          _context2.next = 13;
          return (0, _effects.put)({ type: 'WORKING_HOURS_SAVE_DONE', rooms: workingHours });

        case 13:
          _context2.next = 15;
          return (0, _effects.put)({
            type: _workingHours.WORKING_HOURS.SAVE_SUCCESS,
            rooms: workingHours.data
          });

        case 15:
          _context2.next = 19;
          break;

        case 17:
          _context2.next = 19;
          return (0, _effects.put)({ type: 'WORKING_HOURS_SAVE_FAIL' });

        case 19:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function workingHoursSaga() {
  return _regenerator2.default.wrap(function workingHoursSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_workingHours.WORKING_HOURS.LOAD, loadWorkingHours);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeEvery)(_workingHours.WORKING_HOURS.SAVE, saveWorkingHours);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = workingHoursSaga;
module.exports = exports['default'];